import moment from 'moment';

export const formatDate = (date) => {
  let utc = moment(date, 'YYYY-MM-DD', true);
  if (utc.isValid()) return date;
  return date !== '' ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
};
